import {
  Country,
  GetFlightDateOptionsResponse,
  GetReservationsRequest,
  ReservationsUploadTouristDocumentCreateBody,
  TouristDocumentDto
} from '@appTypes/api.types';
import { DataLoadStatusModel, RequestStateModel, StateFormModel } from '@core/store/store.models';
import { SearchReservationResult } from '@pages/reservations-page/reservations.type';

export class ToursFlightAvailabilityModel {
  data = new RequestStateModel<GetFlightDateOptionsResponse>();
  identifier!: string;
}
export class ReservationsSearchFormDataModel {
  countries = new RequestStateModel<Country[]>();
}

export class ReservationsTouristDocumentsUploadFormModel {
  form = new StateFormModel<ReservationsUploadTouristDocumentCreateBody>();
  /**
   * Progress of the upload in flight. On the API's refusal because the reservation is no longer
   * `New` (KM-5604), `errorMessage` carries what the agent was told — the status it moved to, or
   * the API's own text — so the popup can keep Upload blocked; any other failure leaves it empty.
   */
  uploadState = new DataLoadStatusModel();
  documents: TouristDocumentDto[] = [];
  documentsLoadState = new DataLoadStatusModel();
  /** Progress of the document download in flight; `additionlData.fileId` names which one. */
  downloadState = new DataLoadStatusModel<Pick<TouristDocumentDto, 'fileId'>>();
  /** Progress of the document deletion in flight; `additionlData.fileId` names which one. */
  deleteState = new DataLoadStatusModel<Pick<TouristDocumentDto, 'fileId'>>();
}
export class ReservationsStateModel {
  searchForm = new StateFormModel<GetReservationsRequest>();
  searchFormData = new ReservationsSearchFormDataModel();
  searchResults = new RequestStateModel<SearchReservationResult>();
  /** Progress of the document download in flight; `additionlData.url` names which one. */
  downloadDocumentLoadState = new DataLoadStatusModel<{ url: string }>();
  touristDocumentsUploadForm = new ReservationsTouristDocumentsUploadFormModel();
}
